export const PROFILE_STYLES = {
  CONTAINER:
    'absolute top-6 left-[53.813rem] pc-sm:left-[61.7rem] pc-md-lg:left-[74.875rem] pc-lg:left-[96.875rem] flex flex-col font-metric',
  CONTENT:
    'hover:bg-bw03 flex items-center justify-between min-h-[60px] bg-bw00 pl-[14px] pr-[21px] z-40 cursor-pointer select-none',
  NAME_AND_ICON_CONTAINER: 'flex gap-3 items-center cursor-pointer w-full',
  NAME_CHAR_CONTAINER:
    'h-[34px] w-[34px] rounded-full bg-[#D9F0F3] text-action03 flex self-start items-center justify-center p-2 font-metricSemibold mt-[5px]',
  USERNAME: 'text-action03 font-metricMedium',
  ACCOUNT_DETAILS:
    'w-[300px] min-h-[314px] text-bw08 bg-bw00 border-t border-bw03 w-full shadow-circle-md rounded-b-lg z-40 fadeIn',
  ACCOUNT_AND_ROUTING_NUMBERS: 'relative px-4 flex items-center justify-start w-full border-b border-bw03 h-[82px]',
  ROUTING_NUMBER: 'flex-1 h-[40px] flex flex-col w-full select-none justify-center items-center',
  ACCOUNT_NUMBER:
    'flex-1 h-[40px] flex flex-col w-full justify-center items-center cursor-pointer select-none border-r pr-3 border-bw03',
  COPIED_TEXT: 'relative text-base font-metric text-[#00B16A]',
  COPY_BTN: 'flex items-center text-sm gap-1 font-metricMedium text-action03 w-full pl-3.5',
  NUMBERS_TEXT: 'text-sm text-bw07 font-normal text-left',
  ACCOUNT_INFO_CONTAINER: 'relative px-[16px] py-[20px]',
  ACCOUNT_INFO_CONTENT: 'flex flex-col gap-3.5 h-full justify-center',
  HEADER: 'font-metricMedium text-sm',
  INFO: 'text-bw07 text-sm w-[90%] mb-[5px]',
  PRO_OR_BASIC_ICON: 'absolute top-4 right-4',
  LOGOUT_BTN_CONTAINER: 'w-full flex items-center justify-center hover:bg-[#FCF6F6] py-[14px]',
  LOGOUT_BTN:
    'w-full h-full font-metricMedium text-[#E74343] text-sm flex flex-row-reverse items-center justify-center cursor-pointer z-40',
  LONG_BUSINESS_NAME: 'truncate w-[11.5rem]',
  ACCOUNT_DETAILS_SECTION_WRAPPER: 'flex items-center justify-between w-full',
  ACCOUNT_DETAILS_SECTION_HEADER: 'font-metricRMedium text-bw08 text-[14px]',
  ACCOUNT_DETAILS_SECTION_HEADER_MODAL: 'font-metricRMedium text-bw08 text-[18px]',
  ACCOUNT_DETAILS_SECTION_ACH: 'font-metric text-bw07 text-[14px]',
  ACCOUNT_DETAILS_SECTION_CTA: 'font-metric text-action03 text-[14px] hover:underline',
  COPY_TOOLTIP: `fadeIn before:w-[10px] before:h-[10px] before:bg-bw08 before:border-bw08 before:border-b before:border-r before:absolute
        before:left-[50%] before:translate-x-[-50%] before:rotate-[45deg] before:translate-y-[-55%] before:top-0 absolute z-[9999] top-0 left-[50%] translate-x-[-50%]
        translate-y-[calc(100%+10px)] bg-bw08 border border-bw08 px-[12px] py-[6px] rounded-[6px] shadow-light flex items-center justify-center w-fit`,
  TRANSACTIONS_LIMITS: 'flex items-center flex-row-reverse justify-end w-full font-metricR text-[14px] text-bw08',
  TRANSACTION_HEADER: 'font-metricR text-bw8 text-[14px]',
  ACCOUNT_SWITCHER_TRIGGER: {
    WRAPPER:
      'flex items-center px-[16px] py-[20px] border-bw03 border-t hover:bg-[#F6F7FA] cursor-pointer flex-row-reverse justify-end w-full font-metricR text-[14px] text-bw08',
    CHILDREN_WRAPPER: 'w-full flex items-center justify-between',
    CHILDREN_LEFT_CONTAINER: 'flex items-center gap-[4px]',
    TRIGGER_TITLE: 'font-metricR text-[14px] text-bw08',
    ZERO_STATE_BADGE: 'font-metricRMedium text-[12px] text-bw00 py-[2px] px-[10px] bg-action03 rounded-md',
    PROFILES: {
      WRAPPER: 'flex items-center gap-[4px]',
      LONG_LIST_INDICATOR:
        'rounded-[50%] max-w-[24px] w-[24px] max-h-[24px] h-[24px] box-border border-dashed border-[1px] border-bw05 flex items-center justify-center',
      LONG_LIST_TITLE: 'font-metricR text-[10px] text-bw05',
      PROFILE_ITEM: 'rounded-[50%] w-[24px] h-[24px] flex items-center justify-center relative',
      PROFILE_ITEM_TITLE: 'font-metricRMedium text-[18px] text-bw00',
      PROFILE_ITEM_TITLE_TRIGGER: 'font-metricR text-[12px] text-bw00',
    },
  },
};

export const PROFILE_TEXTS = {
  ROUTING_NUMBER: 'routingNumber',
  ACCOUNT_NUMBER: 'accountNumber',
  ACCOUNT_NUMBER_TITLE: 'Account Number',
  ROUTING_NUMBER_TITLE: 'Routing Number',
  COPIED: 'Copied',
  ACCOUNT_DETAILS_HEADER: 'PROFILE_ACCOUNT_DETAILS_HEADER',
  ACCOUNT_DETAILS_CTA: 'PROFILE_ACCOUNT_DETAILS_CTA',
  LOGOUT_BTN_TEXT: 'PROFILE_COMPONENT_LOG_OUT_BUTTON_TEXT',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE1_HEADER: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE1_HEADER',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE2_HEADER: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE2_HEADER',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE3_HEADER: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE3_HEADER',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE4_HEADER: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE4_HEADER',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE5_HEADER: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE5_HEADER',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE1_DESC: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE1_DESC',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE2_DESC: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE2_DESC',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE3_DESC: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE3_DESC',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE4_DESC: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE4_DESC',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE5_DESC: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_FEATURE5_DESC',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_TITLE: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_TITLE',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_MONTH: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_MONTH',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS1: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS1',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS2: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS2',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS3: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS3',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS4: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_TERMS4',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_BTN: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_BTN',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_BTN_LOADING: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_BTN_LOADING',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_TOOLTIP_HEADER: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_TOOLTIP_HEADER',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_TOOLTIP_CONTENT: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_TOOLTIP_CONTENT',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_TITLE: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_TITLE',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_SUBTITLE1: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_SUBTITLE1',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_MSG: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_MSG',
  PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_BTN: 'PROFILE_COMPONENT_UPGRADE_TO_PRO_SUCCESSES_BTN',
} as const;

export const COPY_TIME = {
  COPY_TIMEOUT: 2000,
};

export const MAX_BUSINESS_NAME_CHARS = 20;

export const BUSINESS_NAME_APPROVED = 'APPROVED';

export const MAX_MULTI_ACCOUNTS_TO_SHOW = 2;
export const MAX_MULTI_ACCOUNTS = 5;
